import { useSettings } from '../../store/settingsStore';
import { resolveMedia } from '../../lib/api';

interface LogoProps {
  className?: string;
  variant?: 'wordmark' | 'icon' | 'both';
  iconClassName?: string;
  wordmarkClassName?: string;
}

export default function Logo({
  className = '',
  variant = 'both',
  iconClassName = 'h-8 w-8',
  wordmarkClassName = 'h-8 w-auto',
}: LogoProps) {
  const { phoneLogo } = useSettings();
  const phoneLogoUrl = phoneLogo ? resolveMedia(phoneLogo) : '/brand-mark-avatar.webp';
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {variant === 'icon' || variant === 'both' ? (
        <img
          src={phoneLogoUrl}
          alt="TECNICELU S.A."
          className={iconClassName}
        />
      ) : null}
      {variant === 'wordmark' || variant === 'both' ? (
        <img
          src="https://assets.tecnicelu.store/logos/brands/wordlogo.png"
          alt="TECNICELU S.A."
          className={wordmarkClassName}
        />
      ) : null}
    </div>
  );
}
